var _excluded = ["borderColor", "anchorElement", "children", "dropDownMargin", "dropDownPosition", "isOpen", "onRequestClose", "disableMinWidthAsAnchor", "showBorder", "menuRootClassName"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import Measure from 'react-measure';
import ReactModal from 'react-modal';
import { color } from "../../../styles/theme";
import { Z_DEPTH_SHADOWS } from "../../../constants/sharedConstants";
import DropDownList from "./DropDownList";
var CONFIG = {
  borderWidth: 1,
  boxShadow: Z_DEPTH_SHADOWS[1],
  defaultMargin: 6,
  modalContentLabel: 'dropDownMenu'
};
var DropDownMenu = /*#__PURE__*/function (_React$Component) {
  function DropDownMenu() {
    var _this;
    _classCallCheck(this, DropDownMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropDownMenu, [].concat(args));
    _defineProperty(_this, "menu", undefined);
    _defineProperty(_this, "state", {
      width: undefined,
      height: undefined
    });
    _defineProperty(_this, "handleMenuFocus", function () {
      if (_this.menu && _this.menu.dropdownList) {
        _this.menu.dropdownList.focus();
      }
    });
    _defineProperty(_this, "onMeasure", function (_ref) {
      var bounds = _ref.bounds;
      _this.setState({
        width: bounds.width,
        height: bounds.height
      });
    });
    return _this;
  }
  _inherits(DropDownMenu, _React$Component);
  return _createClass(DropDownMenu, [{
    key: "getModalStyle",
    value: function getModalStyle() {
      var _this$props = this.props,
        anchorElement = _this$props.anchorElement,
        borderColor = _this$props.borderColor,
        dropDownMargin = _this$props.dropDownMargin,
        dropDownPosition = _this$props.dropDownPosition,
        isOpen = _this$props.isOpen,
        showBorder = _this$props.showBorder;
      var _this$state = this.state,
        width = _this$state.width,
        height = _this$state.height;
      var modalStyle = {
        overlay: {
          position: 'absolute',
          backgroundColor: 'none'
        },
        content: {
          width: 'fit-content',
          top: 'auto',
          bottom: 'auto',
          left: 'auto',
          right: 'auto',
          border: 'none',
          borderRadius: '0',
          boxShadow: 'none',
          padding: '0'
        }
      };
      if (isOpen) {
        // Apply border/box-shadow to modal instead of DropDownList
        if (showBorder) {
          modalStyle.content.border = "".concat(CONFIG.borderWidth, "px solid ").concat(borderColor);
        } else {
          modalStyle.content.boxShadow = CONFIG.boxShadow;
        }

        // Apply positioning styles
        if (anchorElement) {
          var rect = anchorElement.getBoundingClientRect();
          var borderMargin = showBorder ? CONFIG.borderWidth * 2 : 0;

          // Default positioning: bottom left
          var menuTop = rect.bottom + dropDownMargin;
          var menuLeft = rect.left;
          if (width && height) {
            menuTop = dropDownPosition.vertical === 'top' ? rect.top - (height + dropDownMargin + borderMargin) : rect.bottom + dropDownMargin;
            menuLeft = dropDownPosition.horizontal === 'right' ? rect.right - (width + borderMargin) : rect.left;
          }

          // Need to factor in offset from window scrolling
          modalStyle.content.top = "".concat(menuTop + window.pageYOffset, "px");
          modalStyle.content.left = "".concat(menuLeft + window.pageXOffset, "px");
        }
      }
      return modalStyle;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        borderColor = _this$props2.borderColor,
        anchorElement = _this$props2.anchorElement,
        children = _this$props2.children,
        dropDownMargin = _this$props2.dropDownMargin,
        dropDownPosition = _this$props2.dropDownPosition,
        isOpen = _this$props2.isOpen,
        onRequestClose = _this$props2.onRequestClose,
        disableMinWidthAsAnchor = _this$props2.disableMinWidthAsAnchor,
        showBorder = _this$props2.showBorder,
        menuRootClassName = _this$props2.menuRootClassName,
        dropDownListProps = _objectWithoutProperties(_this$props2, _excluded);

      // Set aria-expanded on anchor button
      if (anchorElement) {
        anchorElement.setAttribute('aria-expanded', isOpen);
      }
      var anchorWidth;
      if (!disableMinWidthAsAnchor && anchorElement) {
        var rect = anchorElement.getBoundingClientRect();
        var borderMargin = showBorder ? CONFIG.borderWidth * 2 : 0;
        anchorWidth = rect.width - borderMargin;
      }
      return /*#__PURE__*/React.createElement(ReactModal, {
        contentLabel: CONFIG.modalContentLabel,
        isOpen: isOpen,
        onAfterOpen: this.handleMenuFocus,
        onRequestClose: onRequestClose,
        style: this.getModalStyle(),
        className: menuRootClassName
      }, /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: this.onMeasure
      }, function (_ref2) {
        var measureRef = _ref2.measureRef;
        return /*#__PURE__*/React.createElement("div", {
          ref: measureRef
        }, /*#__PURE__*/React.createElement(DropDownList, _extends({
          minWidth: anchorWidth,
          ref: function ref(menu) {
            return _this2.menu = menu;
          }
        }, dropDownListProps), children));
      }));
    }
  }]);
}(React.Component);
_defineProperty(DropDownMenu, "defaultProps", {
  borderColor: color.primary,
  dropDownMargin: CONFIG.defaultMargin,
  dropDownPosition: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  onRequestClose: function onRequestClose() {}
});
export { DropDownMenu as default };